import { render, staticRenderFns } from "./imputation-list.vue?vue&type=template&id=28fe527f&"
import script from "./imputation-list.vue?vue&type=script&lang=ts&"
export * from "./imputation-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports